import React, { useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSessionId, ThemeContext, useAuthProvider, leadAdapter, pdfDataAdapter, Loader, signupWithCodeAdapter, loginWithCodeAdapter } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import PdfViewer from "@cloudpremise/portal_core/src/themes/mui/components/PdfViewer";
import Card from "@mui/material/Card";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import SimpleInfoCard from "@cloudpremise/portal_core/src/themes/mui/examples/Cards/InfoCards/SimpleInfoCard";
import DefaultInfoCard from "@cloudpremise/portal_core/src/themes/mui/examples/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "@cloudpremise/portal_core/src/themes/mui/examples/Cards/BlogCards/CenteredBlogCard";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";
import Footer from "@cloudpremise/portal_core/src/themes/mui/examples/Footer";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";
import Config from "../Config";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Rellax from "rellax";

import "../styles/home.scss";

const cdnUrl = Config.getCdnUrl();
const bgImage = cdnUrl + "/assets/img/lead2.jpg";

declare const window: Window & typeof globalThis & {
    inlineApexAdaptor: any,
    pdfjsLib: any,
    PDFViewerApplication: any,
    getViewerConfiguration: any,
    onRegistrationFormComplete: any,
    verifyEmailRegistrationAF: any,
    onLoginFormComplete: any,
    verifyEmailLoginAF: any
}

const Home = ({page, basename, history}) => {
    const [ controller ] = useMaterialUIController();
    const { config, user } = controller;
    const headerRef = React.useRef(null);
    const [ authorized, authType ] = useAuthProvider();
    const [state, setState] = React.useState({
        firstName: "",
        lastName: "",
        email: "",
        company: "",
        isSuccess: false,
        loading: false,
        errorMessage: null,
        pdfModal: false,
        pdfData: null,
        verifyCode: false,
        userId: "",
        code: "",
        identifier: "",
        login: false
    });
    const navigate = useNavigate();
    React.useEffect(() => {
        if(!authorized){
            return navigate("/landing"+window.location.search, { replace: true });
        }
    });
    // Setting up rellax
    React.useEffect(() => {
        const parallax = new Rellax(headerRef.current, {
            speed: -6,
        });
        return () => {
            try{
                parallax.destroy();
            }catch(e){}
        }
    }, []);
    function handleChange(e, name){
        setState({
            ...state,
            [name]: e.target.value,
        });
    }
    function onSubmit(e, signup = false){
        e.preventDefault();
        const { firstName, lastName, email, company, identifier, verifyCode, code, login, userId } = state;
        if(verifyCode){
            let completeFunc = null;
            if(login){
                if(typeof(window.onLoginFormComplete) === "function"){
                    completeFunc = window.onLoginFormComplete;
                }
                window.onLoginFormComplete = function(request, event, data){
                    setState({
                        ...state,
                        loading: false,
                        errorMessage: 'Verification code is not valid!'
                    });
    
                    if(completeFunc !== null){
                        window.onLoginFormComplete = completeFunc;
                    }
                }
                window.verifyEmailLoginAF(userId, identifier, code);
            }else{
                if(typeof(window.onRegistrationFormComplete) === "function"){
                    completeFunc = window.onRegistrationFormComplete;
                }
                window.onRegistrationFormComplete = function(request, event, data){
                    console.log("request", request);
                    console.log("event", event);
                    console.log("data", data);
                    setState({
                        ...state,
                        loading: false,
                        errorMessage: 'Unable to complete signup!'
                    });
    
                    if(completeFunc !== null){
                        window.onRegistrationFormComplete = completeFunc;
                    }
                }
                window.verifyEmailRegistrationAF(identifier, code);
            }
            
        }else{
            if(login){
                if(email.length <= 0){
                    return;
                }
                loginWithCodeAdapter(email, (data) => {
                    if(typeof(data) === "object" && data.hasOwnProperty("isSuccess") && data.isSuccess){
                        setState({
                            ...state,
                            identifier: data.identifier,
                            userId: data.userId,
                            loading: false,
                            verifyCode: true
                        });
                    }else{
                        let message = 'Email is not valid!';
                        if(typeof(data) === "object" && data.hasOwnProperty("result")){
                            message = data.result;
                        }
                        setState({
                            ...state,
                            loading: false,
                            errorMessage: message
                        });
                        console.log("Login Failed");
                    }
                });
            }else{
                if(!isFormValid()){
                    return;
                }
                leadAdapter(firstName, lastName, email, company, (data) => {
                    if(typeof(data) === "object" && data.hasOwnProperty("isSuccess") && data.isSuccess){
                        if(signup){
                            signupWithCodeAdapter(email, (data) => {
                                if(typeof(data) === "object" && data.hasOwnProperty("isSuccess") && data.isSuccess){
                                    setState({
                                        ...state,
                                        identifier: data.identifier,
                                        loading: false,
                                        verifyCode: true
                                    });
                                }else{
                                    let message = 'User already exists.';
                                    if(typeof(data) === "object" && data.hasOwnProperty("result")){
                                        message = data.result;
                                    }
                                    setState({
                                        ...state,
                                        loading: false,
                                        errorMessage: message
                                    });
                                    console.log("Signup Failed");
                                }
                            });
                        }else{
                            setState({
                                ...state,
                                loading: false,
                                isSuccess: true,
                                firstName: "",
                                lastName: "",
                                email: "",
                                company: ""
                            });
                        }
                    }else{
                        let message = 'Unable to create lead.';
                        if(typeof(data) === "object" && data.hasOwnProperty("result")){
                            message = data.result;
                        }
                        setState({
                            ...state,
                            loading: false,
                            errorMessage: message
                        });
                    }
                });
            }
            
        }
        
        setState({
            ...state,
            loading: true,
            errorMessage: null
        });
    }
    function onLoginLink(e, status = true){
        e.preventDefault();
        setState({
            ...state,
            errorMessage: null,
            verifyCode: false,
            login: status,
        });
    }
    function isFormValid(){
        const { email } = state;
        if(email.length > 0){
            return true;
        }
        return false;
    }
    if(!authorized){
        return null;
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={config.hideLayout ? 0 : 3}
                ref={headerRef}
                minHeight="75vh"
                width="100%"
                sx={{
                    backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
                        `${linearGradient(
                        rgba(gradients.dark.main, 0.6),
                        rgba(gradients.dark.state, 0.6)
                        )}, url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "grid",
                    placeItems: "center",
                }}
            >
                <Container>
                    <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} sm={12} md={6} lg={8} position="relative">
                            <MDTypography variant="h1" color="white" mb={2}>
                                Welcome to Olympus-Grid
                            </MDTypography>
                            <MDTypography variant="h2" color="white" mb={2}>
                                Explore the Future of Enterprise Architecture
                            </MDTypography>
                            <MDTypography variant="body1" color="white" className="description">
                                Olympus-Grid is your gateway to a streamlined and efficient enterprise ecosystem. Whether you're here to explore, collaborate, or innovate, our platform provides the tools and insights to elevate your business operations.
                            </MDTypography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4} position="relative" component={Grid} p={2}>
                            
                        </Grid>
                    </Grid>
                </Container>
            </MDBox>
            <Card
                sx={{
                p: 2,
                mx: { xs: 2, lg: 3 },
                mt: -8,
                mb: 4,
                boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <Container>
                    <Grid
                        container
                        item
                        xs={12}
                        lg={8}
                        justifyContent="center"
                        mx="auto"
                        textAlign="center"
                        pb={4}
                    >
                        <MDTypography variant="h3" my={4}>
                            What is Olympus-Grid?
                        </MDTypography>
                        <MDTypography variant="body1" color="text" mb={2}>
                            Olympus-Grid is a next-generation enterprise platform designed to unify business processes, integrate intelligent automation, and optimize workflows across industries. It empowers organizations with scalable, flexible, and cutting-edge solutions.
                        </MDTypography>
                    </Grid>
                </Container>
                <Divider />
                <Container sx={{paddingBottom: "24px"}}>
                    <Grid
                        container
                        item
                        xs={12}
                        lg={6}
                        justifyContent="center"
                        mx="auto"
                        textAlign="center"
                    >
                        <MDTypography variant="h2" mb={1} mt={4}>
                            Get Started Today
                        </MDTypography>
                        <MDTypography variant="body1" color="text" mb={3}>
                            Explore our intuitive interface, discover key features, and unlock the potential of enterprise-grade automation.
                        </MDTypography>
                    </Grid>
                    <Grid container spacing={3} justifyContent="center">
                        <Grid item xs={12} md={6} lg={4}>
                            <SimpleInfoCard
                                color="primary"
                                icon="filter_tilt_shift"
                                title="Iris Portal"
                                description="The only UI you or your customers will ever need."
                                direction="center"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <SimpleInfoCard
                                icon="data_object"
                                title="Proteus Objects"
                                description="Define and customize dynamic business objects to fit your needs, stored on the cloud of your choice."
                                direction="center"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <SimpleInfoCard
                                color="warning"
                                icon="add_task"
                                title="Chronos BPM"
                                description="Automate business processes and streamline decision-making."
                                direction="center"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <SimpleInfoCard
                                icon="api"
                                title="Hermes Suite"
                                description="Learn about APIs, asynchronous event model, and the messaging capabilities."
                                direction="center"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <SimpleInfoCard
                                color="warning"
                                icon="gesture"
                                title="Orion Threads"
                                description="Manage asynchronous tasks and background processing."
                                direction="center"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <SimpleInfoCard
                                color="primary"
                                icon="extension"
                                title="Forge Plugins"
                                description="Discover, Install, Upgrade, and Distribute Olympus-Grid components."
                                direction="center"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <SimpleInfoCard
                                icon="backup"
                                title="Eos Administration"
                                description="Create, deploy, evolve."
                                direction="center"
                            />
                        </Grid>
                    </Grid>
                </Container>
                <Divider />
                <Container>
                    <Grid
                        container
                        item
                        xs={12}
                        lg={8}
                        justifyContent="center"
                        mx="auto"
                        textAlign="center"
                        pb={6}
                    >
                        <MDTypography variant="h3" mb={1} mt={4}>
                            Join the Olympus-Grid Community
                        </MDTypography>
                        <MDTypography variant="body1" color="text" mb={2}>
                            Be part of a growing network of innovators and industry leaders. Connect with us through:
                        </MDTypography>
                    </Grid>
                    <Grid container spacing={3} alignItems="center">
                        <Grid item xs={12} lg={8}>
                            <Grid container justifyContent="flex-start">
                                <Grid item xs={12} md={6}>
                                    <MDBox mb={5}>
                                    <DefaultInfoCard
                                        icon="forum"
                                        title="Community Forum"
                                        description="Share ideas and solutions."
                                    />
                                    </MDBox>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <MDBox mb={5}>
                                    <DefaultInfoCard
                                        icon="help_outline"
                                        title="Support Portal"
                                        description="Get assistance and technical support."
                                    />
                                    </MDBox>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <MDBox mb={{ xs: 5, md: 0 }}>
                                    <DefaultInfoCard
                                        icon="text_snippet"
                                        title="Documentation"
                                        description="Access guides, tutorials, and best practices."
                                    />
                                    </MDBox>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
                            <CenteredBlogCard
                                image="https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
                                title="Start Your Journey"
                                description="Dive in, explore the features, and take the first step toward transforming your enterprise with Olympus-Grid"
                                action={{
                                    type: "external",
                                    route: "https://olympus-grid.com",
                                    color: "info",
                                    label: "find out more",
                                }}
                            />
                        </Grid>
                    </Grid>
                </Container>
            </Card>
            <Footer
                links={[
                    { href: "http://www.olympus-grid.com", name: "Olympus-Grid" },
                    { href: "https://www.olympus-grid.com/terms", name: "Terms of Service" },
                    { href: "https://www.olympus-grid.com/privacy", name: "Privacy Policy" },
                ]}
            />
        </DashboardLayout>
    )
}

export default Home;